// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3HVl_","buttons":"PendingPaymentAlert_buttons__1A7c0"};